/**
 * catch で受け取った値を、既存コードが参照している形で読むためのヘルパー。
 *
 * strict では catch の変数は unknown になるため、error?.name のような
 * 従来の書き方がそのままでは通らない。挙動を変えずに移行するため、
 * 「実際に参照しているプロパティだけ」を持つ型として扱う。
 */

/** AWS SDK・fetch・独自 Error が投げる値のうち、本アプリが参照する項目 */
export interface ErrorLike {
  name?: string;
  message?: string;
  code?: string;
  status?: number;
  statusCode?: number;
  response?: {
    status?: number;
  statusCode?: number;
    data?: unknown;
  };
  /** AWS SDK が付与するメタデータ */
  $metadata?: {
    httpStatusCode?: number;
  };
}

/**
 * unknown を ErrorLike として読む。
 * プロパティ参照は元コードと同じくオプショナルなので、
 * null / undefined / 文字列が来ても throw しない。
 */
export const asErrorLike = (error: unknown): ErrorLike => (error ?? {}) as ErrorLike;
